import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class ProjectLevelForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    const view = new CerFormView();
    view.viewMetadata = {
      name: 'projekt-niveau', dataApiName: 'ProjectLevel', text: 'Projektniveauer', textSingular: 'Projektniveau',
      primaryKey: 'id', baseFields: ['id', 'history']
    };

    view.fieldMetadata = [
      { name: 'name', text: 'Niveaunavn' }
    ];

    viewSet.viewAdd(view);
  }
}
